import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import { T, FONT_MONO } from '../constants/tokens';
import { toneColor, opensAlert, formatFeedTime } from '../pages/dashboard/alerts/format';

const useStyles = makeStyles({
  row: {
    display: 'grid',
    gridTemplateColumns: '88px 8px minmax(0, 1fr)',
    alignItems: 'baseline',
    gap: 12,
    width: '100%',
    padding: '10px 0',
    border: 0,
    borderBottom: '1px solid ' + T.hairlineSoft,
    background: 'transparent',
    textAlign: 'left',
    fontFamily: 'inherit',
    color: 'inherit'
  },
  link: {
    cursor: 'pointer',
    '&:hover $text': { textDecoration: 'underline' },
    '&:focus-visible': { outline: '2px solid ' + T.ink, outlineOffset: 2 }
  },
  text: {}
});

/**
 * The event log as a list: when, a dot in the event's colour, what happened.
 *
 * The same rows serve the Overview's "Alert updates" and an alert's timeline.
 * A row that opens an alert (a status change to an actual alert) links to it.
 */
export default function ActivityFeed({ events, onOpenAlert = null, formatTime = formatFeedTime, emptyText = 'Nothing recorded yet.' }) {
  const classes = useStyles();

  if (events == null) return <div style={{ fontSize: 14, color: T.muted }}>Loading…</div>;
  if (events.length === 0) return <div style={{ fontSize: 14, color: T.muted }}>{emptyText}</div>;

  return (
    <div>
      {events.map((event, index) => {
        const linked = onOpenAlert != null && opensAlert(event);
        const Tag = linked ? 'button' : 'div';
        return (
          <Tag
            key={event.getID() ?? index}
            type={linked ? 'button' : undefined}
            className={[classes.row, linked ? classes.link : ''].filter(Boolean).join(' ')}
            style={index === events.length - 1 ? { borderBottom: 0 } : undefined}
            onClick={linked ? () => onOpenAlert(event.getAlertUpdateID()) : undefined}
          >
            <span style={{ fontFamily: FONT_MONO, fontSize: 12, lineHeight: '20px', color: T.muted, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {formatTime(event.getTimestamp())}
            </span>
            <span style={{ width: 8, height: 8, borderRadius: 9999, background: toneColor(event.getTone()), alignSelf: 'center' }} />
            <span className={classes.text} style={{ fontSize: 14, lineHeight: '20px', color: T.ink }}>
              {event.getText()}
            </span>
          </Tag>
        );
      })}
    </div>
  );
}

ActivityFeed.propTypes = {
  events: PropTypes.array,
  onOpenAlert: PropTypes.func,
  formatTime: PropTypes.func,
  emptyText: PropTypes.string
};
